import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store  from './store';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars , faSearch , faMinus , faPlus} from '@fortawesome/free-solid-svg-icons'
import { faFacebookF } from '@fortawesome/fontawesome-free-brands';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'remixicon/fonts/remixicon.css'
import './assets/js/scripts.js'
import  i18n  from '@/plugins/i18n';
import FlagIcon from 'vue-flag-icon';
import './registerServiceWorker'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'


Vue.use(FlagIcon);

library.add(faBars , faSearch, faFacebookF , faMinus , faPlus)
Vue.component('font-awesome-icon', FontAwesomeIcon)

axios.defaults.withCredentials = true
axios.defaults.baseURL = 'https://xpanel.tikibistro.ro/api/';

const logAxios = axios.create({
  baseURL: 'https://xpanel.tikibistro.ro/api/',
  withCredentials: false
})

axios.interceptors.response.use(
  response => response,
  error => {
    try {
      var actionUrl = error && error.config && error.config.url
        ? error.config.url
        : 'unknown'

      var token = localStorage.token

      var logPayload = {
        url: actionUrl,
        method: error && error.config ? error.config.method : null,
        status: error && error.response ? error.response.status : 0,
        status_text: error && error.response ? error.response.statusText : null,
        message: error && error.message ? error.message : null,
        backend_message: error && error.response && error.response.data
          ? error.response.data
          : null,
        network_online: navigator.onLine,
        error_code: error && error.code ? error.code : null,
        user_agent: navigator.userAgent,
        timestamp: new Date().toISOString()
      }

      if (token) {
        logAxios.post('add-log', {
          action: actionUrl,
          description: JSON.stringify(logPayload)
        }, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }).catch(function () {
          // silent log failure
        })
      }

    } catch (e) {
      console.warn('Logging interceptor failed', e)
    }

    return Promise.reject(error)
  }
)


var ERROR_MAP = {

  /* =====================
     AUTH / LOGIN / REGISTER
     ===================== */

  '/api/auth/login_facebook': {
    401: 'Autentificarea cu Facebook a esuat. Incearca din nou.',
    500: 'Serviciul Facebook nu raspunde momentan. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/auth/login_user': {
    401: 'Email sau parola incorecte.',
    400: 'Datele de autentificare sunt invalide.',
    500: 'Autentificarea nu este disponibila momentan. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/auth/register_user': {
    400: 'Datele de inregistrare sunt invalide.',
    409: 'Exista deja un cont cu aceste date.',
    500: 'Inregistrarea nu a putut fi realizata. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     USER / PROFILE
     ===================== */

  '/api/profile': {
    401: 'Nu esti autentificat. Autentifica-te pentru a accesa profilul.',
    500: 'Nu am putut incarca datele profilului. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/user/update_profile': {
    401: 'Nu esti autentificat. Autentifica-te pentru a modifica profilul.',
    400: 'Datele profilului sunt invalide.',
    500: 'Profilul nu a putut fi actualizat. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/user/restore_password': {
    400: 'Datele pentru resetarea parolei sunt invalide.',
    404: 'Utilizatorul nu a fost gasit.',
    500: 'Parola nu a putut fi resetata. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     ADDRESSES
     ===================== */

  '/api/user/add_address': {
    401: 'Trebuie sa fii autentificat pentru a adauga o adresa.',
    400: 'Adresa introdusa este invalida.',
    500: 'Nu am putut salva adresa. Asigura-te ca ai selectat adresa completa din sugestiile Google si ca aceasta contine strada si numarul. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },
  '/api/user/edit_address': {
    401: 'Trebuie sa fii autentificat pentru a modifica adresa.',
    400: 'Datele adresei sunt invalide.',
    500: 'Nu am putut modifica adresa. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/user/delete_address': {
    401: 'Trebuie sa fii autentificat pentru a sterge adresa.',
    500: 'Nu am putut sterge adresa. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     ORDERS
     ===================== */

  '/api/user/orders': {
    401: 'Trebuie sa fii autentificat pentru a vedea comenzile.',
    404: 'Nu exista comenzi.',
    500: 'Nu am putut incarca comenzile. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/order/create': {
    401: 'Trebuie sa fii autentificat pentru a plasa o comanda.',
    400: 'Comanda nu este valida.',
    500: 'Comanda nu a putut fi plasata. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     FAVORITES
     ===================== */

  '/api/user/get_favorites': {
    401: 'Trebuie sa fii autentificat pentru a vedea produsele favorite.',
    500: 'Nu am putut incarca produsele favorite. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/user/add_favorite': {
    401: 'Autentifica-te pentru a adauga produse favorite.',
    500: 'Produsul nu a putut fi adaugat la favorite. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/user/remove_favorite': {
    401: 'Autentifica-te pentru a sterge produse favorite.',
    500: 'Produsul nu a putut fi eliminat din favorite. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     PHONE / SMS
     ===================== */

  '/api/user/send_sms_code': {
    400: 'Numarul de telefon este invalid.',
    429: 'Ai solicitat prea multe coduri. Incearca mai tarziu.',
    500: 'Codul SMS nu a putut fi trimis. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/user/verify_sms_code': {
    400: 'Codul SMS este invalid.',
    401: 'Codul SMS a expirat.',
    500: 'Verificarea codului SMS a esuat. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     VOUCHER
     ===================== */

  '/api/voucher/check': {
    400: 'Codul voucher este invalid.',
    404: 'Voucherul nu exista.',
    409: 'Voucherul nu mai este valabil.'
  },

  /* =====================
     PRODUCTS
     ===================== */

  '/api/products/getProductBySlug': {
    404: 'Produsul nu a fost gasit.',
    500: 'Nu am putut incarca produsul. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  '/api/products/getProductById': {
    404: 'Produsul nu a fost gasit.',
    500: 'Nu am putut incarca produsul. Contacteaza-ne pe WhatsApp la 0747 247 876.'
  },

  /* =====================
     DELIVERY / AREA
     ===================== */

  '/api/get-area': {
    400: 'Adresa selectata nu este in aria de livrare.',
    404: 'Zona de livrare nu a fost gasita.',
    500: 'Nu am putut calcula livrarea pentru această adresă. Asigură-te că alegi adresa completă din sugestiile Google și că aceasta conține strada și numărul exact. Dacă problema persistă, mergi în contul tău și editează adresa — este posibil ca Google să fi actualizat informațiile. Contactează-ne pe WhatsApp la 0747 247 876.'
  }
}

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
